import React, { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: "Home", href: "#home" },
    { label: "Sobre", href: "#sobre" },
    { label: "Abordagem", href: "#abordagem" },
    { label: "Tratamentos", href: "#tratamentos" },
    { label: "Depoimentos", href: "#depoimentos" },
    { label: "Equipe", href: "#equipe" },
    { label: "Espaço", href: "#espaco" },
    { label: "Conteúdos", href: "#conteudos" },
    { label: "Contato", href: "#contato" },
  ];

  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-md z-50 rounded-b-3xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-28">
          <a href="#home" className="hidden sm:flex items-center gap-2 hover:opacity-90 transition-opacity flex-shrink-0">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/LOGOS_mesquita_PRETO-tehIeDzSXNPByEvtAk2jSZUh85dp3z.png"
              alt="Mesquita Psiquiatria e Psicoterapia"
              style={{ width: "auto", height: "70px" }}
              loading="eager"
              className="drop-shadow-sm"
            />
          </a>

          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navItems.slice(1, -1).map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-[#3d3d3d] hover:text-[#204613] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="#contato"
              className="px-5 xl:px-6 py-2.5 bg-[#204613] text-white rounded-lg font-medium hover:bg-[#2d5a1a] transition-all duration-200 text-sm"
            >
              Agendar Consulta
            </a>
          </div>

          <button
            className="lg:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Menu"
          >
            {isOpen ? <X className="w-6 h-6 text-[#204613]" /> : <Menu className="w-6 h-6 text-[#204613]" />}
          </button>
        </div>

        {isOpen && (
          <div className="lg:hidden pb-4 border-t border-[#ACC996]/20">
            <div className="flex flex-col gap-2 pt-4">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm font-medium text-[#3d3d3d] hover:text-[#204613] hover:bg-[#ACC996]/10 transition-colors py-3 px-4 rounded-xl"
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#contato"
                className="mt-2 px-4 py-3 bg-[#204613] text-white rounded-xl font-medium hover:bg-[#2d5a1a] transition-all text-center text-sm"
                onClick={() => setIsOpen(false)}
              >
                Agendar Consulta
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
